import { render, staticRenderFns } from "./InfoPedido.vue?vue&type=template&id=80303d98&scoped=true&"
import script from "./InfoPedido.vue?vue&type=script&lang=js&"
export * from "./InfoPedido.vue?vue&type=script&lang=js&"
import style0 from "./InfoPedido.vue?vue&type=style&index=0&id=80303d98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80303d98",
  null
  
)

export default component.exports